import ApiProvider from '../../../lib/providers/ApiProvider';
import { serviceUtil } from '../../commons/utils/services';
import { HeadersMapping } from '../../commons/mappings/headers.mapping';
import { URLConfiguration } from '../../commons/constants/url.configuration';
import SendSMSRequest from '../../commons/mappings/sendSMSRequest.mapping';

class SendSMSProvider {

    constructor() {
        this.paths              = URLConfiguration.paths;
        this.sendSMSRequest     = new SendSMSRequest();
        this.apiProvider        = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH);
    }

    enviarSMS = async (datosEnvioSMS) => {
        const headers   = HeadersMapping.getHeaderService();
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.otp.enviarSMS, {});
        const request   = this.sendSMSRequest.getRequestSendSMS(datosEnvioSMS);
        let response    = null;
        try {
            response = await this.apiProvider.post(pathNew, request, { headers });
        } catch (error) {
            console.log(error);
        }
        return response
    }

}

export default SendSMSProvider;